import Reader from "reader/containers/Reader";
import Search from "reader/containers/Search";
import Section from "reader/containers/Section";
import NotationResourceDetail from "reader/containers/notation/resource/Detail";
import NotationResourceCollectionDetail from "reader/containers/notation/resource-collection/Detail";

export default {
  Reader,
  Search,
  Section,
  NotationResourceDetail,
  NotationResourceCollectionDetail
};
